<template>
  <div class="ccard-container">
    <div class="header">
      <div>
        <span class="title">用户卡金</span>
        <span class="des">
          <span style="color: #67C23A">可用余额：{{ balance.available }}</span>
          <span style="color: #F56C6C; margin-left: 20px">过期余额：{{ balance.used }}</span>
        </span>
      </div>
      <div>
        <el-link @click="handleShowLog">积分变更记录</el-link>
      </div>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{background:'#F2F2F4', 'text-align': 'center' }"
        style="width: 100%"
      >
        <el-table-column prop="cardId" label="卡金ID" width="80"></el-table-column>
        <el-table-column prop="cardName" label="卡金名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeNames" label="适用门店" show-overflow-tooltip></el-table-column>
        <el-table-column prop="score" label="余额"></el-table-column>
        <el-table-column prop="usedScore" label="已使用"></el-table-column>
        <el-table-column prop="addTime" label="充值时间"></el-table-column>
        <el-table-column prop="expireTime" label="过期时间"></el-table-column>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-link
              style="margin-right: 15px"
              type="success"
              @click="handleEditScore(row.id, 1)"
            >
              新增卡金
            </el-link>
            <el-link
              type="danger"
              @click="handleEditScore(row.id, 2)"
            >
              扣减卡金
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          background
          :current-page="curPage"
          layout="total, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <log ref="logRef"/>
    <el-dialog
      title="增减卡金"
      width="410px"
      :visible.sync="dialogVisible">
      <el-form ref="dataForm" :model="dataForm" :rules="dataRules" label-width="80px" size="small">
        <el-form-item label="卡金积分" prop="score">
          <el-select v-model="dataForm.type" size="small" style="width: 85px; margin-right: 5px;">
            <el-option :value="1" label="增加"/>
            <el-option :value="2" label="扣减"/>
          </el-select>
          <el-input v-model="dataForm.score" type="number" placeholder="请输入卡金" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="编辑原由" prop="description">
          <el-input v-model="dataForm.description" placeholder="请输入备注信息" size="small" clearable/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSaveScore">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import log from "./c_card_log.vue"

export default {
  components: {log},
  props: {
    id: String
  },
  data() {
    return {
      searchForm: {
        userId: ''
      },
      tableData: [],
      /*一共多少条数据*/
      total: 0,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 10,
      balance: 0,
      /*是否加载完成*/
      loading: true,
      addOrUpdateVisible: false,
      dialogVisible: false,
      dataForm: {
        userCardId: '',
        type: 1,
        score: '',
        description: ''
      },
      dataRules: {
        score: [{required: true, message: '请输入卡金', trigger: 'blur'}],
      },
    }
  },
  mounted() {
    this.searchForm.userId = this.id
    this.fetchBalance()
    this.fetchData()
  },
  methods: {
    fetchBalance() {
      let params = this.searchForm
      this.$http.get(`cCardUserCard/balance`, {params}).then(({data}) => {
        this.balance = data.data
      })
    },
    fetchData() {
      let self = this
      let params = self.searchForm
      params.curPage = self.curPage
      params.pageSize = self.pageSize
      this.$http.get(`cCardUserCard/page`, {params}).then(({data}) => {
        this.tableData = data.records
        this.total = data.total
      })
      self.loading = false
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.fetchData()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.fetchData()
    },
    /*搜索查询*/
    handleQuery() {
      this.curPage = 1
      this.tableData = []
      this.fetchData()
    },
    handleShowLog() {
      this.$nextTick(() => {
        this.$refs.logRef.show(this.id)
      })
    },
    handleEditScore(id, type) {
      this.dataForm.score = ''
      this.dataForm.description = ''
      this.dataForm.userCardId = id
      this.dataForm.type = type
      this.dialogVisible = true
    },
    handleSaveScore() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http.post("cCardUserCard/save", JSON.stringify(this.dataForm)).then(({data}) => {
            if (data.code === 200) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.fetchData()
                  this.fetchBalance()
                  this.dialogVisible = false
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.header {
  margin-top: 30px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
}

.title {
  font-weight: bold;
  font-size: 16px;
  font-family: Source Han Sans CN;
}

.des {
  color: #909399;
  margin-left: 30px;
  font-size: 14px;
}

.pagination {
  text-align: center;
  margin-top: 20px;
}

::v-deep .el-dialog__body {
  padding-top: 10px;
}
</style>
